import axios, { AxiosResponse } from 'axios';

import {
  ISessionCompareService,
  ISessionComparePutPayload,
} from '../interfaces';

class SessionCompareService implements ISessionCompareService {
  async getPlans(vertical: string): Promise<Array<Record<string, unknown>>> {
    const url = `/getsessioncomparedata/${vertical}`;

    try {
      const { data }: AxiosResponse = await axios.get(url);
      return data;
    } catch (error) {
      const errorMessage =
        '[SessionCompareService.getPlans] Unable to fetch session compare data';
      console.error(errorMessage, error);
      throw new Error(`${errorMessage}\n ${error}`);
    }
  }

  async addPlans(
    plans: Array<Record<string, unknown>>,
    vertical: string,
  ): Promise<void> {
    await this.updateSession(
      {
        operation: 'add',
        plans,
        vertical,
      },
      'Unable to add plans to session compare data',
    );
  }

  async removePlans(
    plans: Array<Record<string, unknown>>,
    vertical: string,
  ): Promise<void> {
    await this.updateSession(
      {
        operation: 'remove',
        plans,
        vertical,
      },
      'Unable to remove plans from session compare data',
    );
  }

  async updatePlans(
    plans: Array<Record<string, unknown>>,
    vertical: string,
  ): Promise<void> {
    await this.updateSession(
      {
        operation: 'update',
        plans,
        vertical,
      },
      'Unable to update plans in session compare data',
    );
  }

  private async updateSession(
    payload: ISessionComparePutPayload,
    errorMessage?: string,
  ): Promise<void> {
    const url = `/updatesessioncomparedata`;

    try {
      await axios.put(url, payload);
    } catch (error) {
      console.error(errorMessage, error);
      throw new Error(`${errorMessage}\n ${error}`);
    }
  }
}

export const sessionCompareService = new SessionCompareService();
